import { render, staticRenderFns } from "./TentangKami.vue?vue&type=template&id=099bc3ad&scoped=true&"
import script from "./TentangKami.vue?vue&type=script&lang=js&"
export * from "./TentangKami.vue?vue&type=script&lang=js&"
import style0 from "./TentangKami.vue?vue&type=style&index=0&id=099bc3ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099bc3ad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
